// extracted by mini-css-extract-plugin
export default {"landing":"SectionLanding_landing__rxaLd","left":"SectionLanding_left__7-Xuu","right":"SectionLanding_right__z4krl"};